/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Lastupdate2Inputs */

const id_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembaruan Terakhir`)
};

const ms_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemas Kini Terakhir`)
};

const da_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidste Opdatering`)
};

const de_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Aktualisierung`)
};

const en_us2_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Update`)
};

const es_es2_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización`)
};

const es_mx2_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización`)
};

const fil_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huling Update`)
};

const fr_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière mise à jour`)
};

const it_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo aggiornamento`)
};

const hu_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utolsó frissítés`)
};

const nl_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatste update`)
};

const no_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siste oppdatering`)
};

const pl_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnia aktualizacja`)
};

const pt_br2_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última atualização`)
};

const pt_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última atualização`)
};

const ro_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima actualizare`)
};

const fi_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeisin päivitys`)
};

const sv_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste uppdatering`)
};

const vi_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật cuối`)
};

const tr_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son Güncelleme`)
};

const cs_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední aktualizace`)
};

const bg_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последна актуализация`)
};

const ru_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последнее обновление`)
};

const uk_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останнє оновлення`)
};

const ar_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر تحديث`)
};

const hi_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम अपडेट`)
};

const th_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเดตล่าสุด`)
};

const ja_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終更新`)
};

const zh_cn2_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最后更新`)
};

const zh_hant1_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後更新`)
};

const ko_offerdetail_table_lastupdate2 = /** @type {(inputs: Offerdetail_Table_Lastupdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마지막 업데이트`)
};

/**
* | output |
* | --- |
* | "Last Update" |
*
* @param {Offerdetail_Table_Lastupdate2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_lastupdate2 = /** @type {((inputs?: Offerdetail_Table_Lastupdate2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Lastupdate2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_lastupdate2(inputs)
	if (locale === "ms") return ms_offerdetail_table_lastupdate2(inputs)
	if (locale === "da") return da_offerdetail_table_lastupdate2(inputs)
	if (locale === "de") return de_offerdetail_table_lastupdate2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_lastupdate2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_lastupdate2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_lastupdate2(inputs)
	if (locale === "fil") return fil_offerdetail_table_lastupdate2(inputs)
	if (locale === "fr") return fr_offerdetail_table_lastupdate2(inputs)
	if (locale === "it") return it_offerdetail_table_lastupdate2(inputs)
	if (locale === "hu") return hu_offerdetail_table_lastupdate2(inputs)
	if (locale === "nl") return nl_offerdetail_table_lastupdate2(inputs)
	if (locale === "no") return no_offerdetail_table_lastupdate2(inputs)
	if (locale === "pl") return pl_offerdetail_table_lastupdate2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_lastupdate2(inputs)
	if (locale === "pt") return pt_offerdetail_table_lastupdate2(inputs)
	if (locale === "ro") return ro_offerdetail_table_lastupdate2(inputs)
	if (locale === "fi") return fi_offerdetail_table_lastupdate2(inputs)
	if (locale === "sv") return sv_offerdetail_table_lastupdate2(inputs)
	if (locale === "vi") return vi_offerdetail_table_lastupdate2(inputs)
	if (locale === "tr") return tr_offerdetail_table_lastupdate2(inputs)
	if (locale === "cs") return cs_offerdetail_table_lastupdate2(inputs)
	if (locale === "bg") return bg_offerdetail_table_lastupdate2(inputs)
	if (locale === "ru") return ru_offerdetail_table_lastupdate2(inputs)
	if (locale === "uk") return uk_offerdetail_table_lastupdate2(inputs)
	if (locale === "ar") return ar_offerdetail_table_lastupdate2(inputs)
	if (locale === "hi") return hi_offerdetail_table_lastupdate2(inputs)
	if (locale === "th") return th_offerdetail_table_lastupdate2(inputs)
	if (locale === "ja") return ja_offerdetail_table_lastupdate2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_lastupdate2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_lastupdate2(inputs)
	return ko_offerdetail_table_lastupdate2(inputs)
});
export { offerdetail_table_lastupdate2 as "offerDetail.table.lastUpdate" }